
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <span className="text-2xl font-bold text-black">Milajet</span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link to="/our-services" className="text-gray-700 hover:text-black transition-colors">
              Our Services
            </Link>
            <Link to="/about-us" className="text-gray-700 hover:text-black transition-colors">
              About Us
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-black transition-colors">
              Contact
            </Link>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/book-now"
              className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Now
            </Link>
            <a
              href="https://wa.me/905550020006"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-6 py-2 rounded hover:bg-green-600 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-whatsapp-fill text-xl"></i>
              WhatsApp
            </a>
          </div>

          <button className="md:hidden text-gray-700">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
